import { render, staticRenderFns } from "./TheContainer2.vue?vue&type=template&id=4dc6af2b&scoped=true"
import script from "./TheContainer2.vue?vue&type=script&lang=js"
export * from "./TheContainer2.vue?vue&type=script&lang=js"
import style0 from "./TheContainer2.vue?vue&type=style&index=0&id=4dc6af2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6af2b",
  null
  
)

export default component.exports